<template>
  <div style="height: 100%;">
    <!-- <yd-layout id="scrollWrap"> -->
    <!--		<router-view class="Router"></router-view>-->

    <router-view class="Router" v-if="!$route.meta.keepAlive"></router-view>
    <keep-alive exclude="">
      <router-view class="Router" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
<!--    <keep-alive exclude="financingRecordsList,financingList">-->
<!--      <router-view class="Router"></router-view>-->
<!--    </keep-alive>-->
  </div>
  <!-- </yd-layout> -->
</template>

<script>

export default {
  name: 'App',
  data() {
    return {};
  },
  mounted() {
    localStorage.setItem("cip", returnCitySN.cip);
    var device_type = navigator.userAgent;//获取userAgent信息
    var md = new MobileDetect(device_type);//实例化mobile-detect
    var os = md.os();//获取系统
    var model = "";
    if (os == "iOS") {//ios系统的处理
      os = md.os() + md.version("iPhone");
      model = md.mobile();
    } else if (os == "AndroidOS") {//Android系统的处理
      os = md.os() + md.version("Android");
      model = md.mobile();
    }
    // console.log(os + "---" + model);//打印系统版本和手机型号
    localStorage.setItem('osName', os);
    localStorage.setItem('deviceBrand', model)

    // setTimeout(() => {
    //   this.networkStatus()
    // }, 100)

  },
  watch: {
    $route(to, form) {
      const isp = JSON.parse(localStorage.getItem('isLegalPerson'))
      if (to.fullPath === '/aliving/') {
        const res = localStorage.getItem('isFirst')
        if (!res) return
        const res2 = JSON.parse(res)
        if ((localStorage.getItem('phoneNum') === res2.phone) && res2.flag && !isp) {
          this.$router.replace('/')
        }
      }

    }
  },
  updated() {
    // var currentTime=new Date().getTime();
    // var lastRequestTime=localStorage.getItem('lastRequestTime');
    // var runTime = ((currentTime - lastRequestTime) / 1000).toFixed(0);
    // if(runTime >= 30*24*60*60){
    // 	localStorage.setItem("dkId","");
    //     this.$router.replace("/login")
    // }
  },
  methods: {
    networkStatus() {
      // console.log('networkStatus => connection ', navigator)
      window.addEventListener('online',  ()=>{
        // console.log('onLine ')
        // alert('online ' + returnCitySN.cip)
        // localStorage.setItem("cip", returnCitySN.cip)
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://pv.sohu.com/cityjson?ie=utf-8";
        document.body.appendChild(script);
        setTimeout(()=> {
          localStorage.setItem("cip", returnCitySN.cip)
          // alert('online1 ' + returnCitySN.cip)
        }, 200)
      });
      // window.addEventListener('offline',  ()=>{
      //   // console.log('onLine ')
      //   // alert('online ' + returnCitySN.cip)
      //   // localStorage.setItem("cip", returnCitySN.cip)
      //   let script = document.createElement("script");
      //   script.type = "text/javascript";
      //   script.src = "https://pv.sohu.com/cityjson?ie=utf-8";
      //   document.body.appendChild(script);
      //   setTimeout(()=> {
      //     localStorage.setItem("cip", returnCitySN.cip)
      //     alert('offline ' + returnCitySN.cip)
      //   }, 200)
      // });
      // var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      //
      // console.log('networkStatus => connection ', connection)
      // function updateConnectionStatus() {
      //   alert("设备的网络连接从" + type + "变成了" + connection.type);
      // }
      // connection.addEventListener('typechange', updateConnectionStatus);

    }
  },
}
</script>

<style>
.yd-scrollview {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue